// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'

export const CreateStripeCustomer = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService,
        SpinnerMethods

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        create_stripe_customer_api: 'connect-account/customer',
        create_stripe_customer_response: null,
        stripe_customer_created: false,
        stripe_customer_retry_count: 0,
        stripe_customer: {
            first_name: null,
            last_name: null,
            street_1: null, 
            phone_number: null,
            email: null, 
            resident_id: null,
            property_id: null,
            company_id: null
        }

    }),

    /*
	**  Methods
    */
    
    methods: {

        createStripeCustomerHandler: function() {

            try {

                /*
                **  If dev, update segment
                **  @prop: @here
                */

				if (process.env.VUE_APP_STRIPE_ENV == 'development') this.create_stripe_customer_api = 'connect-account-dev/customer';

                /*
                **  Send to API Gateway
                **  @service: @Axios
                */

                axios({
					method: 'post',
					headers: { 'content-type': 'application/json', 'x-api-key': process.env.VUE_APP_API_GATEWAY_API_KEY },
					url: process.env.VUE_APP_API_GATEWAY_BASE_URL + '/stripe/' + this.create_stripe_customer_api,
					data: {
						customer: {
							first_name: this.stripe_customer.first_name,
							last_name: this.stripe_customer.last_name,
							email: this.stripe_customer.email,
							phone_number: this.stripe_customer.phone_number,
							description: 'Resident of ' + this.stripe_customer.street_1 + '.',
							metadata: {
								resident_id: this.stripe_customer.resident_id,
								property_id: this.stripe_customer.property_id,
								company_id: this.stripe_customer.company_id
							}
						}
					}
				})
                .then(response => {

					if (response.data) {

                        /*
                        **  Add to prop
                        **  @prop: @here
                        */

						this.create_stripe_customer_response = response.data;

						/*
						** Set the complete event
						** @prop: @here
						*/

						this.stripe_customer_created = true;

					}

				})
				.catch(error => {

					if (this.stripe_customer_retry_count == 3) {

                        /*
                        **  Send to Bugsnag
                        **  @service: Bugsnag/BugsnagService
                        */

                        this.reportAuthBugsnagError({
                            title: 'Create Connected Account Customer at Stripe',
                            errorType: 'Application',
                            section: 'Events/Stripe',
                            uid: 'jatylSzhxA2jEADoD1ua',
                            error: error
                        });

					} else {

                        /*
                        **  Increment the counter
                        **  @prop: @here
                        */

						this.stripe_customer_retry_count = this.stripe_customer_retry_count + 1;
 
                        /*
                        **  Try again to create the customer
                        **  @method: @here
                        */

						this.createStripeCustomerHandler();

					}

				});

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Create a Connected Account Customer at Stripe',
                    errorType: 'Firestore Database',
                    section: 'Events/Stripe',
                    uid: 'im78Q5XP8VECVSkEPSti',
                    error: e
                });

            }

        }

    }

}